import React from 'react'
import { timeAgo } from '../../utilis/Time';
import { IoMdClose } from "react-icons/io";
const ViewProject = ({ isOpen, onClose, project }) => {
  if (!isOpen) return null;
  const memberDisplayName =
    project?.project_by?.preferredName ||
    [project?.project_by?.firstName, project?.project_by?.lastName].filter(Boolean).join(" ").trim() ||
    project?.project_by?.memberId ||
    "Member";

  return (
    <div
  onClick={onClose}
  className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 p-4"
>
  {/* Modal Content */}
  <div
    onClick={(e) => e.stopPropagation()}
    className="bg-white rounded-xl w-full sm:w-[90%] md:w-[80%] lg:w-[40%] max-w-[900px] 
               max-h-[90vh] overflow-y-auto p-6 shadow-lg"
  >
     <div className="flex justify-between p-4">
        <div className='flex gap-[1rem] items-center'>
            <img src={project?.project_by?.pfp} alt=""  className='w-[60px] h-[60px] rounded-[50%]'/>
            <div className="flex items-start flex-col">
                              <h1 className="font-bold text-[1rem]">
                                {memberDisplayName}
                              </h1>
            
                              <p className="text-gray-400 text-[0.8rem]">
                                {timeAgo(project.createdAt)}
                              </p>
                            </div>   
        </div>
        <button onClick={onClose}>
            <IoMdClose className='text-[20px] text-gray-700'/>
        </button>
    </div>
    <hr className='mb-4'/>
    {/* Modal Header */}
    <div className="flex flex-col mb-4">
      <span className="text-gray-500 text-[16px] font-bold">Title</span>
      <h2 className="text-xl font-bold">{project.title}</h2>
    </div>

    {/* Description */}
    <div className="flex flex-col mb-4">
      <span className="text-gray-500 text-[16px] font-bold">Description</span>
      <p className="text-gray-800 text-[1rem]">{project.description}</p>
    </div>

    {/* Theme Inspiration */}
    <div className="flex flex-col mb-4">
      <span className="text-gray-500 text-[16px] font-bold">Theme Inspiration</span>
      <p className="text-gray-800 text-[1rem]">{project.theme_inspiration}</p>
    </div>

    {/* Primary Goals */}
    <div className="flex flex-col mb-4">
      <span className="text-gray-500 text-[16px] font-bold">Primary Goals</span>
      <p className="text-gray-800 text-[1rem]">{project.primary_goals}</p>
    </div>
     <div className="flex flex-col mb-4">
      <span className="text-gray-500 text-[16px] font-bold">Primary Milestones</span>
      <p className="text-gray-800 text-[1rem]">{project.milestones}</p>
    </div>
     <div className="flex flex-col mb-4">
      <span className="text-gray-500 text-[16px] font-bold">Primary History</span>
      <p className="text-gray-800 text-[1rem]">{project.history}</p>
    </div>

    {/* Skill Areas */}
    <div className="flex flex-col mb-4">
      <span className="text-gray-500 text-[16px] font-bold">Skill Areas</span>
       <ul>
         {project.skill_areas.map((data,index)=>(
           <li className="text-gray-800 text-[1rem]" key={index}>{data}</li>
         ))}
       </ul>
    </div>
 <div className="flex flex-col mb-4">
      <span className="text-gray-500 text-[16px] font-bold">Preferred Support</span>
       <ul>
         {project.preferred_support.map((data,index)=>(
           <li className="text-gray-800 text-[1rem]" key={index}>{data}</li>
         ))}
       </ul>
    </div>
      <div className="flex flex-col mb-4">
      <span className="text-gray-500 text-[16px] font-bold">Project Timeline</span>
      <p className="text-gray-800 text-[1rem]">
  {project.timeline
    ? new Date(project.timeline).toLocaleDateString("en-GB") // dd/mm/yyyy
    : "N/A"}
</p>
    </div>
    
    {/* Image */}
    {project.image && (
      <div className="flex justify-start mb-4">
        <img
          src={project.image}
          alt="Project"
          className="w-full sm:w-[80%] md:w-[60%] lg:w-[50%] h-auto object-cover rounded-md"
        />
      </div>
    )}

    
  </div>
</div>

  );
};

export default ViewProject
